import React from 'react';
import { useLocation } from '@reach/router';
import * as prismic from '@prismicio/client';
import generateId from '@helpers/generate-id';
import Section from '@components/section';
import 'isomorphic-fetch';
import { StyledWrapper, Category, StyledTitle, StyledGrid, StyledArrow } from './categories.styled';

const categoriesIdGenerator = generateId();

interface CategoriesProps {
  title?: string;
  itemsPerRow?: number;
}

const CategoriesTag = ({ title, itemsPerRow = 3 }: CategoriesProps): JSX.Element => {
  const location = useLocation();
  const activeCategory = new URLSearchParams(location.search).get('category') || '';
  const activeTag = new URLSearchParams(location.search).get('tag') || '';
  const repoName = process.env.GATSBY_PRISMIC_REPO_NAME || 'tripmaster';
  const client = prismic.createClient(repoName, { fetch });
  const fetchTags = async () => {
    const allTags = await client.getTags();
    return allTags;
  };

  return (
    <Section backgroundColor="white">
      <StyledWrapper>
        {title && (
          <StyledTitle fontSize="heading3" type="title" fontColor="dark" stringText={title} />
        )}
        <StyledGrid itemsPerRow={itemsPerRow}>
          {fetchTags().then((tags) =>
            tags.map((tag) => {
              const to = `/?tag=${tag}`;

              return decodeURI(activeCategory) === tag ? null : (
                <Category href={to} key={categoriesIdGenerator.next().value}>
                  <span>{tag}</span>
                  <StyledArrow fill="primary" />
                </Category>
              );
            })
          )}
          {activeCategory === '' && activeTag === '' ? (
            <></>
          ) : (
            <Category href="/blog/" key={categoriesIdGenerator.next().value}>
              <span>View All</span>
              <StyledArrow fill="primary" />
            </Category>
          )}
        </StyledGrid>
      </StyledWrapper>
    </Section>
  );
};

export default CategoriesTag;
